import { scrollToElem } from '../../utils'

export default {
    data() {
        return {
            procurementSelect: 'list',
            procurementYearsList: [
                { const: '2019', title: '2019' },
            ],
            procurementYearsPlan: [],
            procurementCurrentYear: '2019',
            procurementCurrentPage: 0,
            procurementPages: 10,
            procurementMiddlePages: [],
            procurementMinPage: 1,
            procurementMaxPage: 5,
            isMobile: null
        }
    },
    mounted() {
        this.procurementGetYears();
        this.isMobile = window.innerWidth <= 1000 ? true : false;

        if (location.pathname === '/about/procurement/') {
            window.addEventListener('resize', () => {
                this.isMobile = window.innerWidth <= 1000 ? true : false;
            })
        }
    },
    methods: {
        procurementCountPages() {
            const pages = document.querySelector('.jsProcurementListPages');
            if (!pages) return;
            this.procurementPages = parseInt(pages.dataset.pagesCount);
        },
        procurementGetYears() {
            const listParent = document.querySelector('.jsProcurementListParent');
            if (!listParent || this.procurementSelect === 'rules') return;
            let years = JSON.parse(listParent.dataset.years)
            this.procurementCurrentYear = years[0];
            years = years.map((el) => {
                return {
                    'const': el,
                    'title': el,
                };
            });
            this.procurementYearsList = years;
        },
        procurementChangeNav(pageNum) {
            this.procurementCurrentPage = pageNum;
            if (this.procurementPages < this.procurementMaxPage) {
                this.procurementMinPage = 1;
                this.procurementMaxPage = this.procurementPages;
                return;
            }
            if (pageNum <= 3) {
                this.procurementMinPage = 1;
                this.procurementMaxPage = 5;
                return;
            }
            if (pageNum + 3 > this.procurementPages) {
                this.procurementMinPage = this.procurementPages - 5;
                this.procurementMaxPage = this.procurementPages;
                return;
            }
            this.procurementMinPage = pageNum - 2;
            this.procurementMaxPage = pageNum + 2;
        },
        mobileCheckout(val) {
            this.procurementMiddlePages = this.procurementPages <= 5
                ? this.getMinPagesVal(this.procurementPages)
                : val === this.procurementPages
                ? [val - 4, val - 3, val - 2, val - 1, val]
                : this.getPagesMobileVal(val);
        },
        cutExtraValues(arr) {
            return arr.filter(val => val <= this.procurementPages);
        },
        getMinPagesVal(arr) {
            let resultArr = [];

            for (let i = 2; i < arr; i++) {
                resultArr.push(i);
            }

            return resultArr;
        },
        getPagesMobileVal(val) {
            let resultArr = [];
            let startPage, EndPage;

            if (val - 1 <= 0) {
                startPage = val;
                EndPage = val + 4;
            }
            else if (val - 2 <= 0) {
                startPage = val - 1;
                EndPage = val + 3;
            }
            else if (val + 2 > this.procurementPages) {
                startPage = val - 3;
                EndPage = val + 1;
            }
            else {
                startPage = val - 2;
                EndPage = val + 2;
            }

            for (let i = startPage; i <= EndPage; i++) {
                resultArr.push(i);
            }

            return this.cutExtraValues(resultArr);
        }
    },
    watch: {
        procurementCurrentYear() {
            this.procurementCurrentPage = 0;
            if (this.procurementSelect === 'rules') return;
            this.$nextTick(() => {
                this.procurementCountPages();
                this.procurementChangeNav(1);
            });
        },
        procurementSelect(val) {
            if (val === 'rules') return;
            this.$nextTick(() => {
                this.procurementGetYears();
            });
        },
        procurementCurrentPage(val, oldVal) {
            this.procurementMiddlePages = this.procurementPages <= 4
                ? this.getMinPagesVal(this.procurementPages)
                : val === this.procurementPages
                ? [val - 2, val - 1, val]
                : (val === 1 || val === 2) && this.procurementPages > 4
                ? [val, val + 1, val + 2, val + 3]
                : [val - 1, val, val + 1];
            if (oldVal !== 0) scrollToElem('procurement-content');
        },
    }
}
